// FIX: Main root error - probably due to passing React Component as a prop
// to a place expecting plain text/JSX. We’ll identify and correct those areas.

// Start from BtechCollegeDetails - ensure correct key names passed:
// Original:
// <HeaderSection
//   collegeName={college?.collegeName}
//   universityDescription={college?.universityDescription}
// />
// Issue: Data from parent has key `collegename`, not `collegeName`

// Updated `BtechCollegeDetails.js` component

import React from "react";
import { Box, Container } from "@chakra-ui/react";
import HeaderSection from "./HeaderSection";
import QuickFactsSection from "./QuickFactsSection";
import HighlightsSection from "./HighlightsSection";
import FacilitiesSpecializationsSection from "./FacilitiesSpecializationsSection";
import CoursesSection from "./CoursesSection";
import CutoffSection from "./CutoffSection";
import AdmissionProcessSection from "./AdmissionProcessSection";
import EntranceExamsSection from "./EntranceExamsSection";
import ScholarshipsPlacementsSection from "./ScholarshipsPlacementsSection";
import FAQsSection from "./FAQsSection";
import ContactSection from "./ContactSection";
import DhakaMedicalCollegeCard from "./DhakaMedicalCollegeCard";

const BtechCollegeDetails = ({ college }) => {
 if (!college) return null;

 const fixString = (val) => (typeof val === "string" ? val : "N/A");

 return (
  <Container maxW="container.xl" py={8}>
   <Box bg="white" boxShadow="md" borderRadius="lg" overflow="hidden">
    <DhakaMedicalCollegeCard college={college} />
    <HeaderSection
     collegeName={fixString(college.collegename)}
     universityDescription={fixString(college.universityDescription)}
    />
    <Box px={6} py={4}>
     <QuickFactsSection
      established={fixString(college.established)}
      type={fixString(college.collegetype)}
      location={fixString(college.location)}
      affiliatedBy={fixString(college.affiliatedby)}
      approvals={
       Array.isArray(college.approval) ? college.approval.join(", ") : "N/A"
      }
      collegeCategory={fixString(college.collegecategory)}
     />

     <HighlightsSection highlights={college?.highlights} />

     <FacilitiesSpecializationsSection
      facilities={college?.facilities}
      specializations={college?.specializations}
     />

     <CoursesSection courses={college.courses} />

     <CutoffSection cutoffs={college.cutoffdata || {}} />

     <AdmissionProcessSection
      admissionProcess={
       typeof college.admissionProcess === "string"
        ? college.admissionProcess.split(".")
        : []
      }
     />

     <EntranceExamsSection
      entranceExams={college.entranceExams}
      hostelFacilities={college.hostelFacilities?.boys || {}}
     />

     <ScholarshipsPlacementsSection
      scholarships={college?.scholarships}
      placements={college?.placements}
     />

     <FAQsSection faqs={college?.faq} />

     <ContactSection
      website={fixString(college?.website)}
      email={fixString(college?.mail)}
      brochureLink={fixString(college?.pdf)}
     />
    </Box>
   </Box>
  </Container>
 );
};

export default BtechCollegeDetails;

// import React from "react";
// import { Box, Container } from "@chakra-ui/react";
// import HeaderSection from "./HeaderSection";

// // Import all sections
// import QuickFactsSection from "./QuickFactsSection";
// import HighlightsSection from "./HighlightsSection";
// import FacilitiesSpecializationsSection from "./FacilitiesSpecializationsSection";
// import CoursesSection from "./CoursesSection";
// import CutoffSection from "./CutoffSection";
// import AdmissionProcessSection from "./AdmissionProcessSection";
// import EntranceExamsSection from "./EntranceExamsSection";
// import ScholarshipsPlacementsSection from "./ScholarshipsPlacementsSection";
// import FAQsSection from "./FAQsSection";
// import ContactSection from "./ContactSection";

// const BtechCollegeDetails = ({ college }) => {
//  // If no college data is provided, return null
//  if (!college) {
//   return null;
//  }

//  return (
//   <Container maxW="container.xl" py={8}>
//    <Box bg="white" boxShadow="md" borderRadius="lg" overflow="hidden">
//     <HeaderSection
//      collegeName={college?.collegeName}
//      universityDescription={college?.universityDescription}
//     />

//     <Box px={6} py={4}>
//      <QuickFactsSection
//       established={college?.established}
//       type={college?.type}
//       location={college?.location}
//       affiliatedBy={college?.affiliatedBy}
//       approvals={college?.approvals}
//       collegeCategory={college?.collegeCategory}
//      />

//      <HighlightsSection highlights={college?.highlights} />

//      <FacilitiesSpecializationsSection
//       facilities={college?.facilities}
//       specializations={college?.specializations}
//      />

//      <CoursesSection courses={college?.courses} />

//      <CutoffSection cutoffs={college?.cutoffs} />

//      <AdmissionProcessSection admissionProcess={college?.admissionProcess} />

//      <EntranceExamsSection
//       entranceExams={college?.entranceExams}
//       hostelFacilities={college?.hostelFacilities}
//      />

//      <ScholarshipsPlacementsSection
//       scholarships={college?.scholarships}
//       placements={college?.placements}
//      />

//      <FAQsSection faqs={college?.faq} />

//      <ContactSection
//       website={college?.website}
//       email={college?.email}
//       brochureLink={college?.brochureLink}
//      />
//     </Box>
//    </Box>
//   </Container>
//  );
// };

// export default BtechCollegeDetails;
